import { Injectable, signal } from '@angular/core';
import { HighlightCode } from '../ai/ai.models';

// Maps each HighlightCode to the settings nav item it illuminates.
const NAV_ITEM_MAP: Partial<Record<HighlightCode, string>> = {
  SUBSCRIPTION_SETTINGS: 'subscription',
  TIME_TO_REMINDER_SETTING: 'charges',
  PAYMENT_PROVIDER_SETTING: 'payment_provider',
  ELECTRICITY_PRICES_SETTING: 'electricity_prices',
  MILEAGE_SETTINGS: 'mileages',
  AUTOMATIC_EXPORT_SETTING: 'automatic_export',
  INDIVIDUAL_KEY_VALUES_SETTING: 'individual_key_values',
  EXTERNAL_BACKEND_PROVIDER_SETTING: 'external_backend_provider',
  USER_PROFILE_SETTING: 'profile',
};

// Maps each HighlightCode to the sidebar item the user must open first.
const MAIN_NAV_MAP: Partial<Record<HighlightCode, string>> = {
  SUBSCRIPTION_SETTINGS: 'settings',
  TIME_TO_REMINDER_SETTING: 'settings',
  DOWNLOAD_EXPORT_DRAFT: 'charges',
  START_BILLING: 'charges',
  PAYMENT_PROVIDER_SETTING: 'settings',
  ELECTRICITY_PRICES_SETTING: 'settings',
  MILEAGE_SETTINGS: 'settings',
  AUTOMATIC_EXPORT_SETTING: 'settings',
  INDIVIDUAL_KEY_VALUES_SETTING: 'settings',
  EXTERNAL_BACKEND_PROVIDER_SETTING: 'settings',
  USER_PROFILE_SETTING: 'settings',
};

@Injectable({
  providedIn: 'root',
})
export class HighlightHandler {
  public readonly activeHighlight = signal<HighlightCode | null>(null);
  public readonly isHighlightingEnabled = signal(true);

  public setHighlight(code: HighlightCode): void {
    this.activeHighlight.set(code);
  }

  public resetHighlight(): void {
    this.activeHighlight.set(null);
  }

  public toggleHighlighting(): void {
    this.isHighlightingEnabled.update((v) => !v);
  }

  /** Returns true when the given settings nav item id should glow. */
  public isNavItemHighlighted(itemId: string): boolean {
    const code = this.activeHighlight();
    return !!code && this.isHighlightingEnabled() && NAV_ITEM_MAP[code] === itemId;
  }

  /** Returns true when the given main sidebar nav item id should glow. */
  public isMainNavItemHighlighted(itemId: string): boolean {
    const code = this.activeHighlight();
    return !!code && this.isHighlightingEnabled() && MAIN_NAV_MAP[code] === itemId;
  }
}
